// extracted by mini-css-extract-plugin
export default {"container":"IconHighlightText-module__container__BqB7p","text":"IconHighlightText-module__text__DTANo"};